import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import { Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import Breadcrumbs from "components/Common/Breadcrumb";
import { GeneralSettingApi } from "apis/GeneralSettingApi";
import Swal from "../../helpers/swal_helper";
function EditGeneralSetting(props) {
    const history = useHistory();
    const { id } = useParams();
    const [key, setKey] = useState("");
    const [value, setValue] = useState(1);
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchGeneralSettingDetails();
    }, [id]);

    const fetchGeneralSettingDetails = () => {
        setFetchLoading(true);
        GeneralSettingApi.getGeneralSettingById(id)
            .then((res) => {
                if (res.data.status) {
                    const generalSettingData = res.data.data;
                    setKey(generalSettingData.key);
                    setValue(generalSettingData.value);
                } else {
                    Swal.fire({
                        title: "Error",
                        text: res.data.message,
                        icon: "error",
                    }).then(() => {
                        history.push("/general-setting");
                    });
                }
                setFetchLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setFetchLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to fetch category details",
                    icon: "error",
                }).then(() => {
                    history.push("/categories");
                });
            });
    };


    const validateForm = () => {
        let tempErrors = {};
        if (!value.trim()) tempErrors.value = props.t("Value is required");
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const formData = new FormData();
            formData.append('id', id);
            formData.append('key', key);
            formData.append('value', value);

            GeneralSettingApi.updateGeneralSetting(formData)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status) {
                        Swal.fire({
                            title: "Success",
                            text: res.data.message,
                            icon: "success",
                        }).then(() => {
                            history.push("/general-setting");
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: res.data.message,
                            icon: "error",
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    Swal.fire({
                        title: "Error",
                        text: err.response.data.message || "Failed to update category",
                        icon: "error",
                    });
                });
        }
    };

    //meta title
    document.title = props.t("Edit General Setting") + " | " + props.t("Salon");

    if (fetchLoading) {
        return (
            <div className="page-content">
                <div className="container-fluid">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">{props.t("Loading...")}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={props.t("General Settings")} breadcrumbItem={props.t("Edit General Setting")} />

                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6}>
                                        <FormGroup>
                                            <Label htmlFor="name">{props.t("Key")}</Label>
                                            <Input
                                                type="text"
                                                id="key"
                                                value={key}
                                                onChange={(e) => setKey(e.target.value)}
                                                invalid={!!errors.key}
                                                readOnly
                                                disabled
                                            />
                                            {errors.key && (
                                                <div className="invalid-feedback">{errors.key}</div>
                                            )}
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <Label htmlFor="name">{props.t("Value")}</Label>
                                                <Input
                                                    type="textarea"
                                                    id="value"
                                                    placeholder={props.t("Enter Valye")}
                                                    value={value}
                                                    onChange={(e) => setValue(e.target.value)}
                                                    invalid={!!errors.value}
                                                />
                                                {errors.value && (
                                                    <div className="invalid-feedback">{errors.value}</div>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                          
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button type="submit" color="primary" disabled={loading}>
                                            {loading ? props.t("Updating...") : props.t("Update")}
                                        </Button>
                                        <Link to="/general-setting" className="btn btn-secondary">
                                            {props.t("Cancel")}
                                        </Link>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

EditGeneralSetting.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(EditGeneralSetting); 